import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCodeLarge"><Path d="M9.31055 5.75L3.06055 12L9.31055 18.25L8.25 19.3105L0.939453 12L8.25 4.68945L9.31055 5.75Z" fill="currentColor"/><Path d="M23.0605 12L15.75 19.3105L14.6895 18.25L20.9395 12L14.6895 5.75L15.75 4.68945L23.0605 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeLarge;
